import React from 'react';
import Button from '../../../components/ui/Button';

const QuickActionPanel = ({ onAddGoal, onModifyGoals, onExportPlan, onRecalculate, isCalculating }) => {
  return (
    <div className="bg-card border border-border rounded-xl p-6">
      <h3 className="text-lg font-semibold text-foreground mb-4">Quick Actions</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <Button
          variant="default"
          iconName="Plus"
          iconPosition="left"
          onClick={onAddGoal}
          fullWidth
        >
          Add New Goal
        </Button>
        <Button
          variant="outline"
          iconName="Edit"
          iconPosition="left"
          onClick={onModifyGoals}
          fullWidth
        >
          Modify Goals
        </Button>
        <Button
          variant="outline"
          iconName="Download"
          iconPosition="left"
          onClick={onExportPlan}
          fullWidth
        >
          Export Plan
        </Button>
        <Button
          variant="secondary"
          iconName="RefreshCw"
          iconPosition="left"
          onClick={onRecalculate}
          loading={isCalculating}
          fullWidth
        >
          Recalculate
        </Button>
      </div>
    </div>
  );
};

export default QuickActionPanel;